import React, { useState } from 'react';
import { ChevronRight } from '@material-ui/icons';
import {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton
} from '@material-ui/core';
import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import Button from '@material-ui/core/Button';
import useWorkingMaxEdit from './hooks/useWorkingMaxEdit';
import PrimaryButton from '../../../view/common/component/PrimaryButton';

const WorkingMaxEdit = props => {
    const {
        userId,
        exerciseId,
        exerciseTitle,
        workingMaxValue,
        workingMaxUnits,
        reload
    } = props;

    const {
        isOpen,
        onClick,
        onClose,
        onSave,
        inputValue,
        onChange
    } = useWorkingMaxEdit(userId, exerciseId, workingMaxValue, reload);

    const units = workingMaxUnits || '';
    const label = `Value ${units}`;
    const title = `${exerciseTitle} - 1 Rep`;
    return (
        <div>
            <IconButton className="workingMaxEdit" onClick={onClick}>
                <ChevronRight />
            </IconButton>
            <Dialog
                open={isOpen}
                onClose={onClose}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle>Edit Working Max</DialogTitle>
                <DialogContent className="workingMaxEditDialog">
                    <DialogContentText>{title}</DialogContentText>
                    <TextField
                        autoFocus
                        value={inputValue}
                        onChange={onChange}
                        margin="dense"
                        id="name"
                        placeholder={workingMaxValue}
                        label={label}
                        type="number"
                        fullWidth
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="primary">
                        Cancel
                    </Button>
                    <PrimaryButton onClick={onSave}>Save</PrimaryButton>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default WorkingMaxEdit;
